export default "__VITE_ASSET__DKT5YEt5__"